<!-- eslint-disable -->
<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            .form__field(v-if="gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_gameWithTime') }}
                .form__field-body
                    cs-multiselect(
                        :multiple='false',
                        :options='gameTypes',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='name',
                        label='name',
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseGameWithTime')",
                        v-model='selectedGameType',
                        @select='params.withTime = $event.withTime'
                    )
            .form__field(v-if="gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
                .form__field-body
                    cs-multiselect(
                        :multiple='false',
                        :options='gameModes',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='name',
                        label='name',
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseMode')",
                        v-model='selectedGameMode',
                        @select='params.mode = $event.mode'
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfUnknowns') }}
                .form__field-body
                    cs-spin-input(
                        :value="params.numOfUnknowns",
                        :max="numOfUnknowns",
                        :min="3",
                        @increase="increaseNumOfUnknowns",
                        @decrease="decreaseNumOfUnknowns",
                        @input="params.numOfUnknowns = $event",
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
                .form__field-body
                    cs-spin-input(
                        :value="params.numOfExamples",
                        :max="numOfExamples",
                        :min="1",
                        @increase="increaseNumOfExamples",
                        @decrease="decreaseNumOfExamples",
                        @input="params.numOfExamples = $event",
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings' && params.numOfExamples > 1")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_examplesComplication') }}
                .form__field-body.checkbox-with-text
                    cs-checkbox(
                        v-model='params.exampleComplication',
                        :disabled="isComplicationDisabled"
                    )
                    help-text(v-if="isComplicationDisabled", :error="true")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_scannerComplicationWarning') }}
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}
                .form__field-body
                    cs-multiselect(
                        :options="availableTableSizes"
                        v-model="params.tableSize"
                        :placeholder="tableLabel(params.tableSize)"
                        :custom-label="tableLabel"
                        :multiple="false"
                        :allow-empty="false"
                    )
            .form__field(v-if="params.withTime && gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_showTime') }}
                .form__field-body
                    cs-multiselect(
                        :options="seconds"
                        v-model="params.showTime"
                        :placeholder="secondsLabel(params.showTime)"
                        :custom-label="secondsLabel"
                        :multiple="false"
                        :allow-empty="false"
                    )
            divider
            slot(name='parameters')
            slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='saveGameMode')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", @click='saveGame')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='saveGame')
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    /*eslint-disable*/
    import GameFormMixin from "../../../utils/trainer/GameFormMixin";
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from "../../../utils/trainer/getInitParameters";
    import { mapState } from 'vuex';
    import _ from "lodash";
    import IntervalConfig from "../../trainer/configs/IntervalConfig";
    import multiplayerFormMixin from "../../../utils/multiplayer/formMixin";

    export default {
        props: {
            slug: String,
            courseType: String,
            id: [Number, String],
            usersIds: [Array, String],
            homeworkId: [Number, String],
            gameMode: String,
            gameId: [Number, String],
            generatorGameIndex: Number,
            generatorSettings: Boolean,
            levelAnswerDuration: Number,
        },
        mixins: [GameFormMixin, multiplayerFormMixin],
        data () {
            return {
                gameTypes: [
                    {
                        name: this.$i18n.t('common.common_gameName_scannerWithoutTime'),
                        withTime: false
                    },
                    {
                        name: this.$i18n.t('common.common_gameName_scannerWithTime'),
                        withTime: true
                    }
                ],
                gameModes: [
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSettingValue_image'),
                        mode: 'image'
                    },
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSettingValue_symbol'),
                        mode: 'symbol'
                    },
                    {
                        name: this.$i18n.tc('trainer.trainer_gameFormSettingValue_mixed', 0),
                        mode: 'mixed'
                    },
                ],
                numOfUnknowns: 15,
                numOfExamples: 100,
                seconds: IntervalConfig.secondsForMemoryGames,
                selectedGameType: null,
                selectedGameMode: null,
                params: null,
            }
        },
        mounted() {
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(this, 'params', getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: _.cloneDeep(this.gamesParameters[this.slug])
                        }
                    }));
                } else {
                    this.params = _.cloneDeep(TrainerGames.games).find(item => item.slug === this.slug).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            this.selectedGameType = _.find(this.gameTypes, { withTime: this.params.withTime });
            this.selectedGameMode = _.find(this.gameModes, { mode: this.params.mode });
        },
        updated () {
            this.selectedGameType = _.find(this.gameTypes, { withTime: this.params.withTime });
            this.selectedGameMode = _.find(this.gameModes, { mode: this.params.mode });
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user
            }),
            isComplicationDisabled () {
                return this.params.numOfExamples <= 1 || Math.pow(this.params.tableSize, 2) - this.params.numOfUnknowns < 2
            },
            availableTableSizes () {
                return Array.from(Array(6), (_, i) => i + 1).slice(1)
                        .filter(num => this.params.numOfUnknowns < Math.pow(num, 2))
            }
        },
        watch: {
            'params.numOfUnknowns': {
                handler (val) {
                    if (val >= this.params.tableSize * this.params.tableSize) {
                        this.params.tableSize = Math.ceil(Math.sqrt(val + 1))
                    }
                }
            },
            'params.withTime': {
                handler (val) {
                    !this.params.showTime && val && (this.params.showTime = this.seconds[0]);
                    !val && (this.params.showTime = null);
                }
            },
        },
        methods: {
            tableLabel (num) {
                return num + ' x ' + num;
            },
            secondsLabel (second) {
                return second + " " + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds')
            },
            decreaseNumOfUnknowns(){
                if (this.params.numOfUnknowns !== 3) {
                    this.params.numOfUnknowns -= 1;
                }
            },
            increaseNumOfUnknowns() {
                if (this.params.numOfUnknowns !== this.numOfUnknowns) {
                    this.params.numOfUnknowns += 1;
                }
            },
            decreaseNumOfExamples() {
                if (this.params.numOfExamples !== 1) {
                    this.params.numOfExamples -= 1;
                }
            },
            increaseNumOfExamples() {
                if (this.params.numOfExamples !== this.numOfExamples) {
                    this.params.numOfExamples += 1;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }

    .checkbox-with-text {
        display: flex;
        align-items: center;
    }
</style>

